var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../elements/Loading';
import { TypeTicket } from './DetailRoutes';
import StretchesDetail from '../Stretches/container/StretchesDetail';
import PacketDetail from '../Packets/container/PacketDetail';
let Detail = class Detail extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            fechaAtrasada: false
        };
        this.handleKeyMinus = (item) => {
        };
        this.handleKeyPlus = (item) => () => {
        };
        this.handleFecha = () => {
        };
        this.quantity = () => {
        };
        this.lineTotal = () => {
        };
        this.handleResetCount = () => {
        };
        this.handleCheckOut = () => {
        };
    }
    render() {
        const { typeTicket, stretch, packet, collaboratorStretch } = this.props;
        switch (typeTicket) {
            case TypeTicket.Stretch:
                return (
                /*<>*/
                React.createElement(StretchesDetail, Object.assign({ stretch: stretch }, this.props))
                /*</>*/
                );
            case TypeTicket.CollaboratorStretch:
                return (React.createElement(React.Fragment, null,
                    React.createElement(StretchesDetail, Object.assign({ stretch: collaboratorStretch }, this.props))));
            case TypeTicket.Packet:
                return (React.createElement(React.Fragment, null,
                    React.createElement(PacketDetail, Object.assign({ packet: packet }, this.props))));
            default:
                return React.createElement("div", null, "Error");
        }
    }
};
Detail = __decorate([
    inject('store'),
    loading(props => {
        if (props.typeTicket === TypeTicket.Stretch) {
            return [
                props.store.stretchesStore.read(props.match.params.id).then(stretch => ({ stretch }))
            ];
        }
        else if (props.typeTicket === TypeTicket.CollaboratorStretch) {
            return [
                props.store.collaboratorStretchesStore.read({
                    operator_id: Number(props.match.params.operator_id),
                    stretch_id: Number(props.match.params.id)
                }).then(collaboratorStretch => {
                    // console.log('collaboratorStretch: ', collaboratorStretch)
                    return { collaboratorStretch };
                })
            ];
        }
        return [];
    }),
    observer
], Detail);
export default Detail;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Detail/Detail.tsx
// module id = 365
// module chunks = 0